

// 新协议
function kkmhhybrid_set_navback_btn (opt = {}) {
  let obj = {
    menuList: opt.menuList
  }
  if (opt.closeAction) {
    obj.closeAction = opt.closeAction
  }
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "set_navback_btn",
    },
    param: {
      ...obj
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}




/**
 * 设置胶囊按钮<br>
 * kkmhhybrid://set_navback_btn，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=169148515}<br>
 * @param {Object} opt 参数对象
 * @param {array} opt.menuList  菜单列表(该参数会覆盖客户端默认提供的菜单选项，点击菜单时回传具体菜单项)
 * @param {Object} opt.closeAction 关闭动作 (如果该参数存在，点击胶囊按钮关闭时，客户端不走默认关闭逻辑，而是回传该参数)
 * @param {Function} opt.callback 回调函数
 */
function set_navback_btn (opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion); 
  if (allow) {
    kkmhhybrid_set_navback_btn(opt)
  } else {
    console.log('无老协议')
  }
}

export default set_navback_btn;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/set_navback_btn/index.js